export default __webpack_public_path__ + "static/media/sms-bulk.692337d0.svg";